import React from 'react';
import './my-merits.scss';
import MeritApi from '../../../apis/merit-api';
import CommonUtils from '../../../utility/common-utilities';
import { ImageConstants } from '../../../constants/constants';
import { getImageSource } from '../../../utility/image-source';
import routerHistory from '../../routes/history';
import Path from '../../routes/routes-path';
import SharedProfile from '../../../../shared-storage/profile';

class MyMerits extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            meritData: { selfLearningMerits: 0, totalActivityMerits: 0 },
            history: [],
            isLoading: true,
            filterType: 'ALL'
        };
    }

    componentDidMount() {
        this.fetchMeritData();
    }

    fetchMeritData() {
        const userInfo = SharedProfile.getProfile();
        const subjectId = userInfo ? userInfo.subjectId : null;
        Promise.all([
            MeritApi.getStudentMerits({ subjectId }),
            MeritApi.getStudentMeritHistory({ limit: 50, subjectId })
        ]).then(([meritsResponse, historyResponse]) => {
            this.setState({
                meritData: meritsResponse.data || this.state.meritData,
                history: historyResponse.data || [],
                isLoading: false
            });
        }).catch(err => {
            console.error("Error fetching merit data", err);
            this.setState({ isLoading: false });
        });
    }

    render() {
        const { meritData, history, isLoading } = this.state;

        if (isLoading) {
            return <div className="text-center mt-5">Loading...</div>;
        }

        return (
            <div className="my-merits-container container mt-4">
                <div className="row mb-4">
                    <div className="col-12">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h2 className="merit-title mb-0">My Merits</h2>
                            <button className="btn view-leaderboard-btn" onClick={() => (this.props.history || routerHistory).push(Path.LEADERBOARD)}>
                                View Leaderboard
                            </button>
                        </div>
                        <div className="merit-dashboard-card p-4 d-flex justify-content-around align-items-center">
                            <div className="text-center">
                                <div className="merit-value">{CommonUtils.convertToFixed(meritData.totalActivityMerits || 0, 2)}</div>
                                <div className="merit-label">Total Merits</div>
                            </div>
                            <div className="text-center">
                                <div className="merit-value">{CommonUtils.convertToFixed(meritData.selfLearningMerits || 0, 2)}</div>
                                <div className="merit-label">Self Learning Merits</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row mt-4">
                    <div className="col-12">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h4 className="history-title mb-0">Activity History</h4>
                            <div className="merit-filter-container">
                                <label className="merit-filter-label">FILTER:</label>
                                <select
                                    className="merit-filter-select"
                                    value={this.state.filterType}
                                    onChange={(e) => this.setState({ filterType: e.target.value })}
                                >
                                    <option value="ALL">All Activities</option>
                                    <option value="SELF">Self Activities</option>
                                    <option value="SCHOOL">School Activities</option>
                                </select>
                            </div>
                        </div>
                        {history.length > 0 ? (
                            <div className="table-responsive merit-history-table-wrapper">
                                <table className="table merit-history-table">
                                    <thead>
                                        <tr>
                                            <th>DATE</th>
                                            <th>ACTIVITY NAME</th>
                                            <th>CHAPTER</th>
                                            <th>BASE MERIT</th>
                                            <th>ACCURACY %</th>
                                            <th>BONUS MERIT</th>
                                            <th>TOTAL MERIT</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {(() => {
                                            let rows = [];
                                            history.forEach((entry) => {
                                                const formattedDate = new Date(entry.dayStart).toLocaleDateString(undefined, { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' });

                                                Object.entries(entry.activityLevel || {}).forEach(([actType, item]) => {
                                                    const processAct = (actData) => {
                                                        const baseMerits = actData.baseMerits !== undefined ? actData.baseMerits : (actData.activityMerits || 0);
                                                        const totalMerits = actData.activityMerits !== undefined ? Number(actData.activityMerits.toFixed(2)) : 0;
                                                        const bonusMerits = Number(Math.max(0, totalMerits - baseMerits).toFixed(2));
                                                        rows.push({
                                                            date: formattedDate,
                                                            actType: actType.replace(/_/g, ' ').toUpperCase(),
                                                            rawActType: actType,
                                                            chapterName: actData.chapterName || '-',
                                                            accuracy: actData.accuracy !== undefined && actData.accuracy !== null ? `${actData.accuracy}%` : '-',
                                                            accuracyVal: actData.accuracy,
                                                            merits: totalMerits,
                                                            baseMerits: baseMerits,
                                                            bonusMerits: bonusMerits
                                                        });
                                                    };
                                                    if (Array.isArray(item)) {
                                                        item.forEach(processAct);
                                                    } else {
                                                        processAct(item);
                                                    }
                                                });
                                            });

                                            const filteredRows = rows.filter(row => {
                                                if (this.state.filterType === 'SELF') {
                                                    // Self activities: self-learning, challenge, practice
                                                    return (
                                                        row.rawActType.startsWith('self_') ||
                                                        row.rawActType === 'challenge_questions' ||
                                                        row.rawActType === 'practice'
                                                    );
                                                } else if (this.state.filterType === 'SCHOOL') {
                                                    // School activities: school assignments, classwork, homework, assessments
                                                    return (
                                                        row.rawActType.startsWith('school_') ||
                                                        row.rawActType === 'school_assessment' ||
                                                        row.rawActType === 'classwork' ||
                                                        row.rawActType === 'homework'
                                                    );
                                                }
                                                return true; // ALL
                                            });

                                            if (filteredRows.length === 0) {
                                                return (
                                                    <tr>
                                                        <td colSpan="7" className="text-center text-muted p-4">
                                                            No activities found matching this filter.
                                                        </td>
                                                    </tr>
                                                );
                                            }

                                            return filteredRows.map((row, index) => (
                                                <tr key={index}>
                                                    <td className="col-date">{row.date}</td>
                                                    <td className="col-activity-name">
                                                        <span className="badge merit-badge">
                                                            {row.actType}
                                                        </span>
                                                    </td>
                                                    <td className="col-chapter">{row.chapterName}</td>
                                                    <td className="col-base-merit">{row.baseMerits}</td>
                                                    <td className="col-accuracy">
                                                        {row.accuracy !== '-' ? (
                                                            <span className={row.accuracyVal >= 70 ? "text-success font-weight-bold" : "text-warning font-weight-bold"}>
                                                                {row.accuracy}
                                                            </span>
                                                        ) : '-'}
                                                    </td>
                                                    <td className="col-bonus-merit font-weight-bold text-success">
                                                        {row.bonusMerits > 0 ? `+${row.bonusMerits}` : '0'}
                                                    </td>
                                                    <td className="col-total-merit font-weight-bold text-success">
                                                        {row.merits}
                                                    </td>
                                                </tr>
                                            ));
                                        })()}
                                    </tbody>
                                </table>
                            </div>
                        ) : (
                            <div className="text-center text-muted p-4">
                                No recent activity found. Start completing assignments to earn merits!
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default MyMerits;
